import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useEffect, useImperativeHandle, useRef, useState, } from 'react';
import { Tooltip } from '../../components/Tooltip';
import { StyledText } from './Text.style';
export const Text = forwardRef(({ size, children, className, color, maxWidth, truncate, fontFamily, fontWeight, fontStyle, showTooltip = false, id, block = true, }, ref) => {
    const textRef = useRef(null);
    useImperativeHandle(ref, () => textRef.current);
    const [isTruncated, setIsTruncated] = useState(false);
    useEffect(() => {
        if (truncate && textRef.current) {
            setIsTruncated(textRef.current.offsetWidth < textRef.current.scrollWidth);
        }
    }, [textRef, truncate]);
    return (_jsx(Tooltip, { text: children, visible: showTooltip && isTruncated, children: _jsx(StyledText, { ref: textRef, size: size, className: className, color: color, maxWidth: maxWidth, truncate: truncate, fontFamily: fontFamily, fontWeight: fontWeight, fontStyle: fontStyle, id: id, block: block, children: children }) }));
});
//# sourceMappingURL=Text.js.map